/**
 * Who may change the Resource Library's records — sites and retailers.
 *
 * ⚠️ NEITHER PAGE ASKED FOR A PERMISSION.
 *
 * Clients were already gated (client.create / client.edit / client.delete) and Contacts were
 * gated alongside them. Sites and Retailers were not: every action on both pages was
 * unconditional, so any role could delete a site or a retailer — view_only included.
 *
 * Reported against the BROKER role: "Broker profile can still edit the other modules in Resource
 * Library (like tag active as inactive for clients, etc). Ideally, they should only have VIEWING
 * access for other modules."
 *
 * Same three-key shape as clients and contacts, so an admin composes exactly the access a role
 * needs, and delete stays separable from edit — it is the action that cannot be undone.
 *
 * ⚠️ UI GATING ONLY, like every other key here. It hides the controls; Row Level Security is
 * what guards the rows themselves.
 */

export const SITE_CREATE_PERMISSION = 'site.create';
export const SITE_EDIT_PERMISSION = 'site.edit';
export const SITE_DELETE_PERMISSION = 'site.delete';

export const RETAILER_CREATE_PERMISSION = 'retailer.create';
export const RETAILER_EDIT_PERMISSION = 'retailer.edit';
export const RETAILER_DELETE_PERMISSION = 'retailer.delete';

/** Every key this module adds, for the server's list and the admin tab. */
export const RESOURCE_PERMISSION_KEYS = [
  SITE_CREATE_PERMISSION,
  SITE_EDIT_PERMISSION,
  SITE_DELETE_PERMISSION,
  RETAILER_CREATE_PERMISSION,
  RETAILER_EDIT_PERMISSION,
  RETAILER_DELETE_PERMISSION,
] as const;

type Can = (permission: string) => boolean;

export const canCreateSites = (can: Can): boolean => can(SITE_CREATE_PERMISSION);
export const canEditSites = (can: Can): boolean => can(SITE_EDIT_PERMISSION);
export const canDeleteSites = (can: Can): boolean => can(SITE_DELETE_PERMISSION);

export const canCreateRetailers = (can: Can): boolean => can(RETAILER_CREATE_PERMISSION);
export const canEditRetailers = (can: Can): boolean => can(RETAILER_EDIT_PERMISSION);
export const canDeleteRetailers = (can: Can): boolean => can(RETAILER_DELETE_PERMISSION);
